// extracted by mini-css-extract-plugin
export default {"notificationContainer":"styles_notificationContainer__I8xxl","notificationBody":"styles_notificationBody__Jghjw","notificationIcon":"styles_notificationIcon__SJSYt"};